<template>
    <div>
        <base-modal ref="billingModal" :id="id" :loading="modalLoading" :centered="true">
            <template>
                <p class="mb-4 pb-2 mt-2">
                    To get started, enter your organization's country and postal code.
                </p>
                <base-form :inline-style="true" v-model="billingAddress" :fields="billingFields"></base-form>
                <p class="text-danger" v-if="billingErrorMessage">
                    {{ billingErrorMessage }}
                </p>
                <button class="btn btn-link px-0 btn-sm" v-if="showSkipBillingAddress" @click="launchBillingPortal()">
                    Skip this step for now
                </button>
                <p class="text-secondary small text-center pt-3 help">
                    Need assistance? Reach out to us at <a
                        href="mailto:support@affinitylearning.ca?subject=Support Request - Account Creation">
                        support@affinitylearning.ca</a>.
                </p>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button
                    @click="saveBillingDetails()"
                    :disabled="modalLoading || !billingAddressValid"
                    class="btn btn-primary"
                    type="button"
                >
                    Continue
                    <span class="icon icon-glyphicons-basic-arrow-thin-right"></span>
                </button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import http from "@/axios.js"
import BaseModal from "@/components/BaseModal"
import BaseForm from "@/components/BaseForm"
import { isoCountries } from "@/assets/js/countries.js"

export default {
    name: "BillingView",
    components: {
        BaseForm,
        BaseModal,
    },
    data() {
        return {
            modalLoading: false,
            billingFields,
            billingAddress: {
                country: "CA",
                postal_code: null
            },
            billingErrorMessage: null,
            showSkipBillingAddress: false,
        }
    },
    computed: {
        id() {
            return String(this._uid)
        },
        userRole() {
            return this.$store.getters.userRole
        },
        billingAddressValid() {
            return Boolean(this.billingAddress.postal_code)
        },
        currentOrganization() {
            return this.$store.getters.currentOrganization
        },
        activeMembership() {
            return this.$store.getters.activeMembership
        },
    },
    methods: {
        async open() {
            this.$store.dispatch("addLoad")
            let response = await http.get(`/api/organizations/${this.currentOrganization.id}/billing/check/`)
            let isConfigured = response.data.status
            if (isConfigured) {
                this.launchBillingPortal()
            } else {
                this.$store.dispatch("removeLoad")
                this.showSkipBillingAddress = false
                this.billingErrorMessage = null
                $(`#${this._uid}`).modal("show")
            }
        },
        saveBillingDetails() {
            this.modalLoading = true
            let vm = this
            http.put(
                `/api/organizations/${this.currentOrganization.id}/billing/`,
                this.billingAddress
            )
            .then(function() {
                vm.launchBillingPortal()
            })
            .catch(function(error) {
                // Give the user the ability to skip the country & postal entry if they're not
                // in Canada. In this case, we probably don't need to worry about sales tax.
                if (vm.billingAddress.country != "CA") {
                    vm.showSkipBillingAddress = true
                }
                vm.billingErrorMessage = error.response.data.message
                vm.modalLoading = false
            })
        },
        launchBillingPortal() {
            this.$store.dispatch("addLoad")
            let vm = this
            http.post("/api/billing/access-portal/", {
                organizationID: this.activeMembership.organization.id,
                returnURL: this.$route.path,
            })
                .then(function (response) {
                    $("#billing-setup-modal").modal("hide")
                    // Navigate to the stripe portal session.
                    window.location = response.data.session_url
                    // window.open(response.data.session_url)
                })
                .finally(function () {
                    vm.modalLoading = false
                })
        },
    }
}

const billingFields = [
    {
        name: "Country",
        key: "country",
        type: "select",
        options: isoCountries
    },
    {
        name: "Postal Code",
        maxlength: 7,
        key: "postal_code",
    },
]
</script>

<style>

</style>